import { LanguagePreferenceEnum } from 'models/LanguagePreference'
import { TFunction } from 'react-i18next'
import { object, z, string } from 'zod'
import { createAccountSettingsEmailSchema, emailEmptyErrorArgs } from './common-schemas'

export const createSchema = (t: TFunction) => (
  createAccountSettingsEmailSchema(t).and(
    object({
      media: string(),
      language: LanguagePreferenceEnum
    })
  ).refine(
    (d) => d.media !== 'Electronic' || d.email,
    emailEmptyErrorArgs(t)
  )
)

export type MedicareYouHandbookForm = z.infer<ReturnType<typeof createSchema>>
